import React from "react";

const DebitOptionsBus = (props) => {
  const options = [
    {
      text: 'Help, I’m having trouble with my terminal.',
      handler: props.actionProvider.DebitBus1,
      id: 1
    },
    {
      text: 'What is an "Acquirer"?',
      handler: props.actionProvider.DebitBus2,
      id: 2
    },
    {
      text: 'I’m opening a small personal business. Is INTERAC Debit just for bigger businesses or does it make sense for me to use it to accept payments too?',
      handler: props.actionProvider.DebitBus3,
      id: 3
    },
    {
      text: 'How do I get an INTERAC Debit terminal?',
      handler: props.actionProvider.DebitBus4,
      id: 4
    },
    {
      text: 'What fees are associated with INTERAC Debit?',
      handler: props.actionProvider.DebitBus5,
      id: 5
    },
    {
      text: 'I’m planning to open a new business. How long does it typically take to set up the contract and install the Interac Debit terminal?',
      handler: props.actionProvider.DebitBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default DebitOptionsBus;